import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActionnaireDialogService } from '../../dialogs/actionnaire-dialog/actionnaire-dialog.service';
import { AdministreDialogService } from '../../dialogs/administre-dialog/administre-dialog.service';
import { BanqueDialogService } from '../../dialogs/banque-dialog/banque-dialog.service';
import { CiviliteDialogService } from '../../dialogs/civilite-dialog/civilite-dialog.service';
import { GroupeDialogService } from '../../dialogs/groupe-dialog/groupe-dialog.service';
import { MouvementDialogService } from '../../dialogs/mouvement-dialog/mouvement-dialog.service';
import { PaysDialogService } from '../../dialogs/pays-dialog/pays-dialog.service';
import { TypeBanqueDialogService } from '../../dialogs/type-banque-dialog/type-banque-dialog.service';
import { GlobalSearchDialogComponent } from './global-search-dialog.component';

export interface SearchResultData {
  type: string;
  id: number;
  label: string;
  sublabel?: string;
  actionnaireId?: number;
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchDialogService {
  constructor(
    private _dialog: MatDialog,
    private _actionnaire: ActionnaireDialogService,
    private _administre: AdministreDialogService,
    private _banque: BanqueDialogService,
    private _civilite: CiviliteDialogService,
    private _groupe: GroupeDialogService,
    private _mouvement: MouvementDialogService,
    private _pays: PaysDialogService,
    private _typeBanque: TypeBanqueDialogService
  ) {}

  private static readonly DIALOG_ID = 'global-search-dialog';

  openSearchDialog(): void {
    if (this._dialog.getDialogById(GlobalSearchDialogService.DIALOG_ID)) return;
    this._dialog.open(GlobalSearchDialogComponent, {
      id: GlobalSearchDialogService.DIALOG_ID,
      width: '560px',
      maxWidth: '95vw',
      panelClass: 'global-search-dialog',
      autoFocus: true,
      restoreFocus: true,
    });
  }

  /** Ouvre le dialog approprié pour un résultat de type "données". */
  openEntityDialog(r: SearchResultData): void {
    switch (r.type) {
      case 'actionnaire':
        this._actionnaire.openDialog(r.id);
        break;
      case 'administre':
        this._administre.openDialog(r.id);
        break;
      case 'banque':
        this._banque.openDialog(r.id);
        break;
      case 'civilite':
        this._civilite.openDialog(r.id);
        break;
      case 'groupe':
        this._groupe.openDialog(r.id);
        break;
      case 'pays':
        this._pays.openDialog(r.id);
        break;
      case 'typebanque':
        this._typeBanque.openDialog(r.id);
        break;
      case 'mouvement':
        this._mouvement.openDialog(r.id, r.actionnaireId ?? 0);
        break;
      default:
        break;
    }
  }
}
